﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { TasksGanttDatum } from '../../models/DmaTasks/tasks-gantt-datum';

import Gantt, {
    Tasks,
    Toolbar,
    Item as GanttToolbarItem,
    Dependencies,
    Resources,
    ResourceAssignments,
    Column,
    Editing,
    HeaderFilter,
    StripLine
} from 'devextreme-react/gantt';

import 'devexpress-gantt/dist/dx-gantt.min.css';

//todo
export const currentDate = new Date(Date.now());

export interface Props {
    height?: number;
    taskListWidth?: number;
}

export default function TasksGanttComponent(props: Props) {
    const [tasks, setTasks] =
        useState<TasksGanttDatum[]>([]);

  //  const [taskTypes, setTaskTypes] =
    //    useState<TaskType[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div> 

            <Gantt
                taskListWidth={props.taskListWidth ? props.taskListWidth : 500}
                scaleType="sixHours"
                height={props.height ? props.height : 700}
                rootValue={-1}>

                <Tasks dataSource={tasks} keyExpr="taskId" titleExpr="name"
                    startExpr="startDate" endExpr="endDate" />

                {/*
                <Dependencies dataSource={dependencies} />
                <Resources dataSource={resources} />
                <ResourceAssignments dataSource={resourceAssignments} />
                */}

                <Column dataField="name" caption="Task" width={160} />
                <Column dataField="assignedToName" caption="Assignee" width={160} />
                <Column dataField="startDate" caption="Start Date" format="MM/dd/yyyy" width={150} />
                <Column dataField="endDate" caption="End Date" format="MM/dd/yyyy" width={150} />

                <Toolbar>
                    <GanttToolbarItem name="undo" />
                    <GanttToolbarItem name="redo" />
                    <GanttToolbarItem name="separator" />
                    <GanttToolbarItem name="collapseAll" />
                    <GanttToolbarItem name="expandAll" />
                    <GanttToolbarItem name="separator" />
                    <GanttToolbarItem name="addTask" />
                    <GanttToolbarItem name="deleteTask" />
                    <GanttToolbarItem name="separator" />
                    <GanttToolbarItem name="showResources" />
                    <GanttToolbarItem name="showDependencies" />
                    <GanttToolbarItem name="separator" />
                    <GanttToolbarItem name="zoomIn" />
                    <GanttToolbarItem name="zoomOut" />
                </Toolbar>

                <StripLine start={currentDate} title="Current Time" cssClass="current-time" />
                <Editing enabled />
                <HeaderFilter visible />
            </Gantt>


            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function getTasks() {
        await CrudFunctions.getData("dmatasks/tasksganttdata")
            .then((data) => {
                console.log("tasks:");
                console.log(data);

                let rawTasks = data as TasksGanttDatum[];

                if (rawTasks) {
                    rawTasks.forEach((t) => {
                        t.startDate = new Date(t.startDate);
                        t.endDate = new Date(t.endDate);
                    });

                    setTasks(rawTasks);
                }                
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Tasks");
            });
    }

    async function getAllData() {
        await getTasks();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}


